<template>
  <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" :class="cls" :style="innerStyle" :stroke-width="strokeWidth" :stroke-linecap="strokeLinecap" :stroke-linejoin="strokeLinejoin" @click="onClick"><g clip-path="url(#clip0_11977_31186)" stroke="transparent"><circle cx="24" cy="24" r="24" fill="url(#paint0_linear_11977_31186)"></circle><path d="m19.926 31 3.815-20.4-8.331 17.691L19.926 31ZM36.251 35.083 19.917 31l-1.74 5.834 18.074-1.75Z" fill="#fff"></path><path d="m19.924 31 16.326 4.083L31 30.417 19.924 31Z" fill="#fff"></path><path d="m15.405 28.29 2.77 8.543L19.926 31l-4.52-2.71ZM23.741 10.544 19.926 31l6.99-14-3.175-6.456Z" fill="#fff"></path></g><defs><linearGradient id="paint0_linear_11977_31186" x1="24" y1="0" x2="24" y2="48" gradientUnits="userSpaceOnUse"><stop stop-color="#7E9AFF"></stop><stop offset="1" stop-color="#9C9AFF"></stop></linearGradient><clipPath id="clip0_11977_31186"><path fill="#fff" d="M0 0h48v48H0z"></path></clipPath></defs></svg>
</template>

<script lang="ts">
import { defineComponent, computed, CSSProperties } from 'vue';
import { getPrefixCls } from '../../_utils/global-config';
import { isNumber } from '../../_utils/is';

export default defineComponent({
  name: 'IconDefaultAvatarPrismLightColor',
  props: {
    size: {
      type: [Number, String],
    },
    strokeWidth: {
      type: Number,
      default: 4
    },
    strokeLinecap: {
      type: String,
      default: 'butt',
      validator: (value: any) => {
        return ['butt', 'round', 'square'].includes(value);
      }
    },
    strokeLinejoin: {
      type: String,
      default: 'miter',
      validator: (value: any) => {
        return ['arcs', 'bevel', 'miter', 'miter-clip', 'round'].includes(value);
      }
    },
    rotate: Number,
    spin: Boolean
  },
  emits: {
    click: (ev: MouseEvent) => true,
  },
  setup(props, { emit }) {
    const prefixCls = getPrefixCls('icon');
    const cls = computed(() => [prefixCls, `${prefixCls}-default-avatar-prism-light-color`, { [`${prefixCls}-spin`]: props.spin }]);
    const innerStyle = computed(() => {
      const styles: CSSProperties = {};
      if (props.size) {
        styles.fontSize = isNumber(props.size) ? `${props.size}px` : props.size;
      }
      if (props.rotate) {
        styles.transform = `rotate(${props.rotate}deg)`;
      }
      return styles;
    });
    const onClick = (ev: MouseEvent) => {
      emit('click', ev);
    };

    return {
      cls,
      innerStyle,
      onClick,
    };
  }
});
</script>
